import PropTypes from 'prop-types';
import CardsStackItem from './components/CardsStackItem';
import styles from './cardsStack.module.scss';
import { useMemo, useState } from 'react';
import clsx from 'clsx';

const CardsStack = ({ cards, selectedCard, onCardClick }) => {
    const [cardHeights, setCardHeights] = useState({});

    const handleCardResize = (cardKey, height) => {
        setCardHeights((prevHeights) => {
            if (prevHeights[cardKey] !== height) {
                prevHeights[cardKey] = height;

                return { ...prevHeights };
            }

            return prevHeights;
        });
    };

    const selectedCardIndex = useMemo(() => {
        return cards.findIndex((card, index) => (card.key || index) === selectedCard);
    }, [cards, selectedCard]);

    return (
        <div className={styles.cards}>
            {cards?.map((card, index) => {
                const indexDifference = index - selectedCardIndex;
                const isSelected = indexDifference === 0;
                const widthDiff = Math.abs(indexDifference) * 18 * 2;
                const cardKey = card.key || index;

                return (
                    <div
                        key={cardKey}
                        className={clsx(
                            styles.cardWrapper,
                            !isSelected && styles.notSelectedCardWrapper
                        )}
                        style={{
                            width: `calc(100% - ${widthDiff}px)`,
                            height: isSelected ? cardHeights[cardKey] : 90,
                            zIndex: cards.length - Math.abs(indexDifference),
                            marginTop: indexDifference > 0 ? '-50px' : 0,
                            marginBottom: indexDifference < 0 ? '-50px' : 0
                        }}
                        onClick={() => onCardClick(cardKey)}>
                        <CardsStackItem
                            onHeightChange={(height) => handleCardResize(cardKey, height)}
                            isSelected={isSelected}
                            backgroundColor={card.backgroundColor}
                            textColor={card.textColor}
                            title={card.title}
                            closedTitle={card.closedTitle}
                            unselectedTitlePosition={indexDifference > 0 ? 'bottom' : 'top'}>
                            {card.component}
                        </CardsStackItem>
                    </div>
                );
            })}
        </div>
    );
};

CardsStack.propTypes = {
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            closedTitle: PropTypes.string,
            backgroundColor: PropTypes.string,
            textColor: PropTypes.string,
            component: PropTypes.node,
            key: PropTypes.string
        })
    ),
    onCardClick: PropTypes.func,
    selectedCardIndex: PropTypes.number
};

export default CardsStack;
